import PopupWindowContainer from './PopupWindowContainer';

export default PopupWindowContainer;
